'use client'

import { useEffect } from 'react'
import { getNatsConnection, sc } from '../utils/nats-client'
import type { Subscription } from 'nats.ws'
import { EUserPortfolioQueryKey } from '@repo/services'
import { getQueryClient } from '@repo/services/provider/get-query-client'

export function useUserSync(userId: number | undefined) {
  useEffect(() => {
    if (!userId) {
      return
    }

    let subscription: Subscription | undefined

    const setupSubscription = async () => {
      try {
        const nc = await getNatsConnection()
        const subject = `user.${userId}.sync`
        console.log('🚀 ~ setupSubscription ~ subject:', subject)

        subscription = nc.subscribe(subject)

        const handleMessage = async () => {
          for await (const msg of subscription!) {
            try {
              const data = sc.decode(msg.data)

              console.log('🚀 ~ sync:', data)

              // Invalidate portfolio query to refetch updated data
              getQueryClient().invalidateQueries({
                queryKey: [EUserPortfolioQueryKey.USER_PORTFOLIO],
              })
            } catch (error) {
              console.error('Error decoding message:', error)
            }
          }
        }

        handleMessage().catch((error) => {
          console.error('Error handling NATS message:', error)
        })
      } catch (error) {
        console.error('❌ Failed to setup NATS subscription:', error)
      }
    }

    setupSubscription()
  }, [userId])
}
